var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contents"},[_c('select-menu',{staticClass:"mb-1",attrs:{"text":['Deutsch'],"values":['de']},model:{value:(_vm.locale),callback:function ($$v) {_vm.locale=$$v},expression:"locale"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }